import script from "./ListBooks.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListBooks.vue?vue&type=script&lang=ts&setup=true"

import "./ListBooks.vue?vue&type=style&index=0&id=b6831c7a&lang=css"

export default script